<template>
    <div class="banner">
        <div class="banner-content">
            <div style="width: 620px;" class="intro">{{ intro }}</div>
            <div class="l-con">
                <h1>高端软件咨询及定制开发服务</h1>
                <div class="info">以产品力与运营思维,结合技术研发与交付能力,为企业交付具<br/>有创造型的软件产品及企业级系统应用</div>
                <div class="item-con">
                    <div class="item">
                        <img src="https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/template1/logo/icon01%402x.png" />
                        <div class="title">用户增长</div>
                    </div>
                    <div class="item">
                        <img src="https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/template1/logo/icon02%402x.png" />
                        <div class="title">产品咨询</div>
                    </div>
                    <div class="item">
                        <img src="https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/template1/logo/icon03%402x.png" />
                        <div class="title">流程设计</div>
                    </div>
                    <div class="item">
                        <img src="https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/template1/logo/icon04%402x.png" />
                        <div class="title">运营探讨</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
export default {
    setup() {
        const store = useStore()
        const intro = computed(() => {
            return store.state.intro
        })
        return{
            intro
        }
    }
}
</script>
<style scoped lang="scss">
    .banner{
        width: 100%;
        background-image: url("https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/bannerbg2.png");
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        min-height: 726px;
        .banner-content{
            margin: 0 auto 0;
            width: 1200px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            padding-left: 75px;
            min-height: 726px;
            .intro {
                font-size: 28px;
                font-family: 'PingFangSC-Regular';
                font-weight: 400;
                color: #000;
            }
            .l-con{
                h1{
                    font-size: 47px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #000000;
                    line-height: 75px;
                }
                .info{
                    font-size: 23px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #666666;
                    line-height: 28px;
                    margin-top: 43px;
                }
                .item-con{
                    display: flex;
                    align-items: center;
                    margin-top:44px;
                    gap:51px;
                    .item{
                        display: flex;
                        align-items: center;
                        gap:10px;
                        img{
                            width: 25px;
                            height: 25px;
                        }
                        .title{
                            font-size: 19px;
                            font-family: PingFangSC-Medium, PingFang SC;
                            font-weight: 500;
                            color: #000000;
                            line-height: 27px;
                        }
                    }
                }
            }
        }
    }
</style>